import * as t from "io-ts";

import fetchApi from "ui-io/fetch-api";
import { TodoNoteIO } from "../../task-io";
export const LIST_COMPANY_NOTES = "LIST_COMPANY_NOTES";
export const getBrandNotes = ({
  companyID,
}: {
  companyID: string;
}) => {
  return {
    queryKey: [LIST_COMPANY_NOTES, companyID],
    queryFn: () =>
      fetchApi({
        service: "admin-service",
        method: "GET",
        pathname: `/company-notes/${companyID}`,
        codec: t.array(TodoNoteIO),
      }),
  };
};
